// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1660":"329f5128","3163":"329f5128","5378":"edb30248"}[chunkId] + ".chunk.css";
};